module.exports = "/_next/static/images/ScanArrow-94e126e29169b386ffcb0624cbdb65e5.png";